import type { Component, ParentProps } from "solid-js";
import Header from "../Header/Header.js";
import Footer from "../Footer/Footer.js";

const Main: Component = (props: ParentProps) => {
  return (
    <>
      <Header />
      <div class="flex-grow flex-shrink-0 flex-auto flex flex-col">
        {props.children}
      </div>
      <Footer />
    </>
  );
};

export default Main;
